import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
import { CompositeModel } from '../../models/complex/composite.model';
import { ODataTimeZoneOutModel, TimeZoneModel } from '../../models/complex/time-zone.model';
import {
    NotificationIdentifierModel,
    ODataNotificationIdentifierOutModel,
} from '../../models/low-level/notification-identifier.model';
import { MultilineTextModelOptions } from '../../models/options/multiline-text-model-options';
import { DateModel } from '../../models/primitive/date.model';
import { MultilineTextModel, ODataTextLineOutModel } from '../../models/primitive/multiline-text.model';
import { TextModel } from '../../models/primitive/text.model';
import { TimeModel } from '../../models/primitive/time.model';
import { ConfigService } from '../../services/config/config.service';
import { CustomInjector } from '../../services/custom-injector/custom-injector';

export class EscalationModel extends CompositeModel {
    public frontId: TextModel;
    public qmNum: TextModel;
    public maNum: TextModel;
    public frontDate: DateModel;
    public frontTime: TimeModel;
    public messageType: TextModel;
    public longTextInfo: MultilineTextModel;
    public readonly escalationStatus = 'HSC';

    private timeZone: TimeZoneModel;
    public constructor(public notificationId: NotificationIdentifierModel) {
        super('EscalationModel');

        const injector = CustomInjector.getInjector();
        const translate = injector.get(TranslateService);
        const configService = injector.get(ConfigService);

        this.timeZone = new TimeZoneModel();

        // setup child models
        this.frontId = <TextModel>this.set(new TextModel('FrontId', notificationId.frontId));
        this.qmNum = <TextModel>this.set(new TextModel('NotificationNo', notificationId.qmNum));
        this.maNum = <TextModel>this.set(new TextModel('TaskNumber', notificationId.maNum));
        this.messageType = <TextModel>this.set(new TextModel('MessageType', this.escalationStatus));
        this.frontDate = <DateModel>this.set(new DateModel('Date', moment()));
        this.frontTime = <TimeModel>this.set(new TimeModel('Time', this.frontDate.value));

        const escalationTextPlaceHolder = configService.getShowPlaceHolderForEscalationText()
            ? <string>translate.instant('ESCALATION_TEXT_PLACEHOLDER')
            : <string>translate.instant('ESCALATION_COMMENT');
        this.longTextInfo = <MultilineTextModel>this.set(
            new MultilineTextModel(
                'EscalationLtextSet',
                '',
                new MultilineTextModelOptions({
                    placeholder: escalationTextPlaceHolder,
                    required: true,
                }),
            ),
        );
    }

    public getOutModel(): ODataEscalationOutModel {
        const outmodel = <ODataEscalationOutModel>super.getOutModel();
        const timeZoneOutmodel = this.timeZone.getOutModel();
        _.merge(outmodel, timeZoneOutmodel);
        return outmodel;
    }
}

export interface ODataEscalationOutModel extends ODataNotificationIdentifierOutModel, ODataTimeZoneOutModel {
    MessageType: string;
    Date: string;
    Time: string;
    EscalationLtextSet: ODataTextLineOutModel[];
}
